import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { IMAGES } from "../../data/config";
import { Reveal } from "../common/Reveal";

export const MeetDrIrma = () => (
  <section className="py-24 lg:py-32" data-testid="meet-dr-irma-section">
    <div className="container-site">
      <div className="relative grid items-center gap-12 lg:grid-cols-12">
        <Reveal className="lg:col-span-5">
          <div className="relative">
            <div className="absolute -left-4 -top-4 h-full w-full border border-gold/50" aria-hidden="true" />
            <img
              src={IMAGES.portrait}
              alt="Dr. Irma Shida Abu Samah"
              loading="lazy"
              className="relative aspect-[4/5] w-full object-cover object-top"
              data-testid="dr-irma-portrait"
            />
          </div>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-7 lg:pl-8">
          <p className="eyebrow">Meet Dr. Irma</p>
          <h2 className="mt-4 font-serif text-3xl tracking-tight text-navy sm:text-4xl lg:text-5xl">
            Dr. Irma Shida <span className="italic text-emerald">Abu Samah</span>
          </h2>
          <p className="mt-4 text-xs font-semibold uppercase tracking-[0.25em] text-gold" data-testid="dr-irma-roles">
            Dentist • Entrepreneur • Consultant • Speaker • Author
          </p>
          <p className="mt-8 text-base leading-relaxed text-ink/75">
            Twenty years of building businesses, leading teams and working with
            people taught Dr. Irma something simple:
          </p>
          <blockquote className="mt-6 border-l-2 border-gold pl-6 font-serif text-xl italic leading-relaxed text-navy sm:text-2xl" data-testid="dr-irma-quote">
            Before we prescribe a solution, we must understand the diagnosis.
          </blockquote>
          <p className="mt-6 text-base leading-relaxed text-ink/75">
            Her work brings clinical thinking into human, business and
            organisational development — combining observation, experience,
            strategy and practical action.
          </p>
          <Link to="/about" className="btn-outline mt-10" data-testid="about-dr-irma-cta">
            About Dr Irma <ArrowRight className="h-4 w-4" strokeWidth={1.5} />
          </Link>
        </Reveal>
      </div>
    </div>
  </section>
);
